import React from 'react';
import { useNode } from '@craftjs/core';
import { makeStyles } from '@material-ui/core/styles';

import { ImageSettings } from './ImageSettings';
import { Resizer } from '../Resizer';

const useStyles = makeStyles({
  image: {
    width: '100%',
    height: '100%',
    display: 'block',
    objectFit: 'cover',
  },
  placeholder: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    border: '2px dashed #ccc',
    textAlign: 'center',
    backgroundColor: '#f8f8f8',
  },
});

export const Image = ({ src, alt, width, height }) => {
  const classes = useStyles();
  const { connectors: { connect, drag } } = useNode();

  return (
    <Resizer
      propKey={{ width: 'width', height: 'height' }}
      style={{ width, height }}
    >
      {src ? (
        <img src={src} alt={alt} className={classes.image} />
      ) : (
        <div className={classes.placeholder}>
          Añade una URL de imagen
        </div>
      )}
    </Resizer>
  );
};

Image.craft = {
  displayName: 'Imagen',
  props: {
    src: 'https://via.placeholder.com/300x200',
    alt: 'Imagen de ejemplo',
    width: '300px',
    height: '200px',
  },
  related: {
    toolbar: ImageSettings,
  },
};